export default {"src":"/_next/static/media/PARAA.97851d1c.svg","height":18,"width":18};